import { getPageContent } from "../apis"
import MobileHeaderSearch from "../components/MobileHeaderSearch"
import { useFetch } from "../hooks/useFetch"
import useWidth from "../hooks/useWidth"
import MobileHeader from "../layout/MobileHeader"
import Navbar from "../layout/Navbar"

export default ({ title }) => {
    const width= useWidth()
    const [page] = useFetch(getPageContent, {}, title)

    return(
        <>
            {
                width > 992
                    ? <Navbar gradient />
                    : <MobileHeader>
                        <MobileHeaderSearch placeholder="Search Tours & Events"  />
                    </MobileHeader>
            }

            <section className="mobile-top-space desktop-top-space">
                <div className="container">
                    <h3 className="custom-text-font">{ title || "Terms Of Service" }</h3>

                    {
                        page.content ? <p>{page.content}</p>
                        : <>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit, aliquid rerum voluptatibus nobis doloremque laborum iure quibusdam nulla, corporis ipsam incidunt, porro magnam? Nam, necessitatibus eius dolores nihil pariatur fugiat.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit, aliquid rerum voluptatibus nobis doloremque laborum iure quibusdam nulla, corporis ipsam incidunt, porro magnam? Nam, necessitatibus eius dolores nihil pariatur fugiat.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit, aliquid rerum voluptatibus nobis doloremque laborum iure quibusdam nulla, corporis ipsam incidunt, porro magnam? Nam, necessitatibus eius dolores nihil pariatur fugiat.</p>
                        </>
                    }
                </div>
            </section>
        </>
    )
}